var _defs, _rect, _path, _circle, _line, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGdprInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ef5028;}.cls-2{fill:none;stroke:#595959;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.4165,
    y: 19.5,
    width: 33,
    height: 27,
    rx: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M35.91666,21a3.0034,3.0034,0,0,1,3,3V42a3.0034,3.0034,0,0,1-3,3h-24a3.00339,3.00339,0,0,1-3-3V24a3.00339,3.00339,0,0,1,3-3h24m0-3h-24a6.01763,6.01763,0,0,0-6,6V42a6.01763,6.01763,0,0,0,6,6h24a6.01763,6.01763,0,0,0,6-6V24a6.01763,6.01763,0,0,0-6-6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.5,
    cy: 30.5,
    r: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.5,
    y1: 31.5,
    x2: 23.5,
    y2: 37.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.5,19.5h-22v-7a11,11,0,0,1,22,0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGdprInactive);
export default __webpack_public_path__ + "static/media/icon-gdpr-inactive.9c4dc13cbc4d8742d5e054da3927e21e.svg";
export { ForwardRef as ReactComponent };